import TextArea from "@pathwright/ui/src/components/form/form-textarea/TextArea"
import styled from "styled-components"

const ParagraphEditWrapper = styled.div`
  width: 100%;

  @media screen and (max-width: 480px) {
    .blocks-paragraph__textarea div:first-of-type {
      align-items: stretch;
    }
  }
`

const ParagraphQuestionEditor = () => {
  return (
    <ParagraphEditWrapper style={{ width: "100%" }}>
      <TextArea className="blocks-paragraph__textarea" minRows={3} disabled />
    </ParagraphEditWrapper>
  )
}

export default ParagraphQuestionEditor
